
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalSquare as ObiBuoyConicalSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-square.js';
 
 
 

 
 export const ObiBuoyConicalSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-square',
   elementClass: ObiBuoyConicalSquareElement,
   events: {
     
   }
  });
 
 